import { render, staticRenderFns } from "./batchsend.vue?vue&type=template&id=6c38ff0e&scoped=true&"
import script from "./batchsend.vue?vue&type=script&lang=js&"
export * from "./batchsend.vue?vue&type=script&lang=js&"
import style0 from "./batchsend.vue?vue&type=style&index=0&id=6c38ff0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c38ff0e",
  null
  
)

export default component.exports